/* eslint-disable */
import { useEffect, useRef, useMemo, useCallback, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { useInventoryAnalysisBetaStore } from './InventoryAnalysisBetaStore';
import { DateRangePicker, Toggle, SelectPicker, DatePicker } from 'rsuite';
import { Button } from '@/Components/ui/button';
import {
	Filter,
	Loader2,
	RefreshCcw,
	SquareArrowOutUpRight,
	ChevronLeft,
	ChevronRight,
	ChevronDown,
} from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { formActions, modalActions } from '@/Actions';
import StatsComp from '../ProductionAnalysis/StatsComp';
import alert from '@/Images/alertImages.png';
import producedIcon from '@/Images/prodManualIcon_with_bg.svg';
import MultiPoModal from '@/Components/Modals/MultiPoModal/multiPoModal';
import RmPriceUpdateModal from '@/Components/Modals/RmPriceUpdateModal/RmPriceUpdate';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import drawerActions from '@/Actions/drawer.actions';
import { checkNull, fetchList, filtersInfoChip, useQuery } from '@/Helpers';
import {
	quickPickerRanges,
	formatDate,
	TAB_BUTTON_BASE,
	TAB_BUTTON_ACTIVE,
	TAB_BUTTON_INACTIVE,
	handleTimeFilterClick,
	timeChartClick,
	geographyChartClick,
	productChartClick,
	getTimeFilterListForTab,
	getCurrentDateInfo,
	yearOptions,
} from './inventoryAnalysisBetaHelper';
import urls from '@/Constants/urls';
import moment from 'moment';
import 'rsuite/dist/rsuite.min.css';
import { BackdropLoader } from '@/Components/Loaders';
import {
	initialChartTabs,
	analysisPhaseTypes,
	analysisSubTypes,
} from './config';
import { Tabs, TabsList, TabsTrigger } from '@/Components/ui/tabs';
import { useAuth } from '@/Components/Auth/Login/auth';
import { CustomModal } from '@/Components/Modals/CustomModal';
import { showProductDetailsToCustomerInProductionAnalysis } from '@/config/config';
import aiPackaging from '@/Services/aiPackaging.services';
import ProductionDetailsModalContent from '../ProductionAnalysis/ProductionDetailsModalContent';
import notificationServices from '@/Services/notification.services';

function InventoryAnalysisBeta() {
	const chartRef = useRef(null);
	const dispatch = useDispatch();
	const params = useQuery();
	const tab = params.get('tab');
	const dateRangeFilter = params.get('dateRangeFilter');
	const timeFilterTab = params.get('timeFilter');
	const {
		tabs,
		dataFilterTabs,
		selectedTab,
		setSelectedTab,
		perUnitToggle,
		setPerUnitToggle,
		dateRangeObj,
		setDateRangeObj,
		chartTabs,
		grouping,
		loading,
		dateFilter,
		selectedChartTab,
		setSelectedChartTab,
		analysisPhase,
		setAnalysisPhase,
		analysisSubType,
		setAnalysisSubType,
		setDateFilter,
		setGrouping,
		filters,
		setFilters,
		cardsData,
		chartData,
		cacheTime,
		setIsCache,
		fetchInitialData,
	} = useInventoryAnalysisBetaStore();

	const brands = useSelector(
		(state) => state?.form?.BRANDS?.data?.LIST || []
	);
	const shifts = useSelector((state) => state?.analytics?.SHIFT_LIST);
	const { appConfig } = useAuth();
	const today = useMemo(() => new Date(), []);
	const currentYear = useMemo(() => today.getFullYear(), [today]);
	const currentMonth = useMemo(() => today.getMonth() + 1, [today]);
	const [selectedYear, setSelectedYear] = useState(currentYear);
	const [selectedMonth, setSelectedMonth] = useState(currentMonth);
	const [timeFilterList, setTimeFilterList] = useState([]);
	const [selectedTimeFilter, setSelectedTimeFilter] = useState(null);
	const [monthPickerOpen, setMonthPickerOpen] = useState(false);
	const isMonginisCustomer = appConfig?.customerId === 63;
	const monthPickerRef = useRef(null);
	const isShowModal = true;

	const filtersInfo = {
		header: {
			store: false,
			product: false,
			statusAndTypes: false,
			process: false,
		},
		store: {
			show: true,
			text: 'Store',
			multiSelect: true,
		},
		allProcessType: {
			show: false,
			text: 'Select Process',
			multiSelect: true,
		},
		product: {
			show: false,
			text: 'Select Products',
			singleSelect: true,
		},
		type: {
			text: 'Select Shift',
			show: false,
			list: shifts?.map((item) => {
				return {
					label: item?.shiftName,
					type: item?.id,
				};
			}),
		},
	};
	useEffect(() => {
		if (isMonginisCustomer) {
			// setSelectedChartTab('count');
		}
		if (tab || timeFilterTab || dateRangeFilter) {
			const cleanTab = tab?.replace(/^"(.*)"$/, '$1') || 'periodWise';
			const cleanTimeFilterTab =
				timeFilterTab?.replace(/^"(.*)"$/, '$1') || '';
			const parsedDateRangeObj = dateRangeFilter
				? JSON.parse(dateRangeFilter)
				: {
						from: new Date(moment().startOf('month')),
						to: new Date(),
				  };
			const dateRange = parsedDateRangeObj
				? {
						from: new Date(parsedDateRangeObj.from),
						to: new Date(parsedDateRangeObj.to),
				  }
				: {
						from: new Date(moment().startOf('month')),
						to: new Date(),
				  };
			const newList =
				getTimeFilterListForTab(cleanTab, brands, selectedYear) ?? [];
			setTimeFilterList(newList);
			if (cleanTimeFilterTab) {
				setSelectedTimeFilter(cleanTimeFilterTab);
			} else if (cleanTab === 'periodWise') {
				setSelectedTimeFilter(newList[1]?.value);
			} else {
				setSelectedTimeFilter(newList[0]?.value);
			}
			setSelectedTab(cleanTab);
			setDateRangeObj(dateRange);
			setDateFilter({
				year: selectedYear ?? currentYear,
				month: currentMonth,
				day: null,
				hour: null,
				week: null,
				currentSelection:
					cleanTab !== 'periodWise'
						? newList[0]?.value
						: newList[1]?.value,
			});
			if (cleanTab === 'geographyWise') {
				setGrouping({
					active: true,
					type: cleanTab,
					currentSelection: cleanTimeFilterTab || newList[0]?.value,
					selection: { region: null, city: null },
				});
			} else if (cleanTab !== 'periodWise') {
				setGrouping({
					active: true,
					type: cleanTab,
					currentSelection: cleanTimeFilterTab || newList[0]?.value,
					selection: {},
				});
			}
			return;
		}
		if (selectedTab && brands.length >= 0) {
			const newList = getTimeFilterListForTab(
				selectedTab,
				brands,
				selectedYear
			);
			setTimeFilterList(newList);
			setDateFilter({
				year: selectedYear ?? currentYear,
				month: currentMonth,
				day: null,
				hour: null,
				week: null,
				currentSelection: newList[1]?.value,
			});
			setSelectedTimeFilter(newList[1].value);
			if (selectedTab === 'geographyWise') {
				setGrouping({
					active: true,
					type: selectedTab,
					currentSelection: newList[0]?.value,
					selection: { region: null, city: null },
				});
				setSelectedTimeFilter(newList[0].value);
			} else if (selectedTab !== 'periodWise') {
				setGrouping({
					active: true,
					type: selectedTab,
					currentSelection: newList[0]?.value,
					selection: {},
				});
				setSelectedTimeFilter(newList[0].value);
			}
		}
	}, [brands.length]);

	useEffect(() => {
		dispatch(
			formActions.gateway({
				entity: 'BRANDS',
				method: 'LIST',
				req: { params: { id: '' } },
			})
		);
		// if (Array.isArray(shifts) && shifts?.length === 0) {
		// 	fetchList(dispatch, 'shifts');
		// }
	}, []);

	useEffect(() => {
		const state = useInventoryAnalysisBetaStore.getState();
		state.setupSubscriptions();
		if (state.filters && Object.keys(state.filters).length > 0) {
			state.fetchInitialData(false);
		}
	}, []);

	// useEffect(() => {
	// 	if (Array.isArray(shifts) && shifts.length > 0 && !filters?.type) {
	// 		setFilters({
	// 			...filters,
	// 			type: shifts[0]?.id,
	// 		});
	// 	}
	// }, [shifts]);

	const handleTabChange = useCallback(
		(value) => {
			setSelectedTab(value);
			const baseList = getTimeFilterListForTab(
				value,
				brands,
				selectedYear
			);
			setTimeFilterList(baseList);
			setFilters({
				...filters,
				timeTypeFilter: null,
			});
			if (value === 'periodWise') {
				setDateFilter({
					year: selectedYear ?? currentYear,
					month: currentMonth,
					day: null,
					hour: null,
					week: null,
					currentSelection: baseList[1]?.value,
				});
				setSelectedTimeFilter(baseList[1]?.value);
			} else if (value === 'geographyWise') {
				setGrouping({
					active: true,
					type: value,
					currentSelection: 'brand',
					selection: { region: null, city: null },
				});
				setSelectedTimeFilter(baseList[0]?.value);
			} else {
				setGrouping({
					active: true,
					type: value,
					currentSelection: baseList[0]?.value,
					selection: {},
				});
				setSelectedTimeFilter(baseList[0]?.value);
			}
		},
		[setSelectedTab, selectedYear, setFilters, filters]
	);

	const handleCustomDateChange = useCallback(
		(dateRange) => {
			setDateRangeObj({
				from: dateRange[0],
				to: dateRange[1],
			});
		},
		[setDateRangeObj]
	);

	const handleChartTabChange = useCallback(
		(value) => {
			setSelectedChartTab(value);
			if (
				value === 'weight' &&
				selectedTab === 'periodWise' &&
				selectedTimeFilter === 'day'
			) {
				setFilters({
					...filters,
					timeTypeFilter: 'PerHour',
				});
			} else {
				setFilters({
					...filters,
					timeTypeFilter: null,
				});
			}
		},
		[setSelectedChartTab, selectedTab, selectedTimeFilter, filters]
	);

	const handleFilterChange = useCallback(
		(value) => {
			setFilters({
				...filters,
				timeTypeFilter: value,
			});
		},
		[filters, setFilters]
	);
	const handleTimeFilterChange = useCallback(
		(value) => {
			if (selectedTab === 'geographyWise') {
				const order = timeFilterList?.map((item) => item?.value);
				const currentIndex = order.indexOf(selectedTimeFilter);
				const newIndex = order.indexOf(value);
				if (newIndex > currentIndex) {
					return;
				}
			}
			if (value === 'month' && selectedTimeFilter === 'month') {
				setMonthPickerOpen(true);
				return;
			}
			if (value === 'year') {
				setSelectedMonth(currentMonth);
			}
			const monthToUse = value === 'year' ? currentMonth : selectedMonth;
			const baseList = getTimeFilterListForTab(
				selectedTab,
				brands,
				selectedYear,
				monthToUse,
				value,
				timeFilterList
			);
			setTimeFilterList(baseList);
			handleTimeFilterClick(
				value,
				selectedTab,
				setSelectedTimeFilter,
				setDateFilter,
				setGrouping,
				selectedYear,
				monthToUse,
				grouping
			);
			if (
				value === 'day' &&
				(selectedChartTab === 'weight' || selectedChartTab === 'count')
			) {
				setFilters({
					...filters,
					timeTypeFilter: 'PerHour',
				});
			} else {
				setFilters({
					...filters,
					timeTypeFilter: null,
				});
			}
		},
		[
			selectedTab,
			brands,
			getTimeFilterListForTab,
			setDateFilter,
			handleTimeFilterClick,
			selectedYear,
			selectedMonth,
			selectedTimeFilter,
			currentMonth,
			filters,
			setFilters,
			timeFilterList,
			selectedChartTab,
		]
	);

	const handleMonthSelect = useCallback(
		(date) => {
			if (date) {
				const year = date.getFullYear();
				const month = date.getMonth() + 1;
				const monthLabel = new Date(year, month - 1, 1).toLocaleString(
					'default',
					{ month: 'short' }
				);

				setSelectedYear(year);
				setSelectedMonth(month);
				setSelectedTimeFilter('month');
				setDateFilter({
					...dateFilter,
					year: year,
					month: month,
					day: null,
					hour: null,
					week: null,
					currentSelection: 'month',
				});

				const newList = getTimeFilterListForTab(
					selectedTab,
					brands,
					year
				);
				setTimeFilterList(
					newList.map((item) => {
						if (item.value === 'month') {
							return { ...item, label: monthLabel };
						}
						if (item.value === 'year') {
							return { ...item, label: year.toString() };
						}
						return item;
					})
				);
			}
			setMonthPickerOpen(false);
		},
		[
			selectedTab,
			brands,
			dateFilter,
			setDateFilter,
			getTimeFilterListForTab,
		]
	);

	const series = useMemo(() => {
		return (
			chartData?.dataset?.map((item) => {
				return {
					name: item.label,
					type: item?.type,
					stack: item?.stack,
					data: item?.data,
					...(item?.type?.toLowerCase() === 'line'
						? {
								lineStyle: item?.lineStyle,
								itemStyle: item?.itemStyle,
								symbol: 'circle',
								symbolSize: 10,
								showSymbol: true,
						  }
						: {
								itemStyle: {
									color: item?.backgroundColor,
									borderColor: item?.borderColor,
									borderWidth: 1,
								},
								barMaxWidth: 120,
						  }),
				};
			}) || []
		);
	}, [chartData?.dataset, selectedTab]);

	const markPointData = useMemo(() => {
		return chartData?.priceValidated?.notValidatedMonth ?? [];
	}, [chartData?.priceValidated?.notValidatedMonth]);

	const zeroProductionLabels = useMemo(() => {
		const labels = chartData?.labels || [];
		const productionHappened = chartData?.productionHappened || [];
		if (labels.length === 0 || productionHappened.length === 0) return [];

		const today = new Date();
		const currentYear = today.getFullYear();
		const currentMonth = today.getMonth() + 1;
		const currentDay = today.getDate();
		const isCurrentYearAndMonth =
			dateFilter?.year === currentYear &&
			dateFilter?.month === currentMonth;

		return labels.filter((label, idx) => {
			const producedWeight = productionHappened[idx] || 0;
			if (producedWeight !== 0) return false;
			if (isCurrentYearAndMonth) {
				const labelDay = parseInt(label, 10);
				if (!isNaN(labelDay) && labelDay > currentDay) {
					return false;
				}
			}

			return true;
		});
	}, [
		chartData?.labels,
		chartData?.productionHappened,
		dateFilter?.year,
		dateFilter?.month,
	]);

	const option = useMemo(() => {
		const labels = chartData?.labels || [];
		const labelsLength = labels.length;
		const showSlider = labelsLength > 12;

		return {
			tooltip: {
				trigger: 'axis',
				axisPointer: { type: 'shadow' },
				formatter: function (params) {
					let tooltip = '<div style="padding: 5px;">';
					tooltip += `<div style="font-weight: bold; margin-bottom: 8px; font-size: 14px;">${params[0].name}</div>`;

					params.forEach((item) => {
						const value = parseFloat(item.value).toFixed(2);
						tooltip += `
			<div style="margin-bottom: 4px;">
				${item.marker} 
				<span style="color: #666;">${item.seriesName}:</span> 
				<span style="font-weight: bold; color: #000;">${value} ${
							selectedChartTab === 'weight'
								? 'Kg'
								: selectedChartTab === 'count'
								? 'pcs'
								: ''
						}</span>
			</div>
		`;
					});

					tooltip += '</div>';
					return tooltip;
				},
				backgroundColor: '#fff',
				borderColor: '#ccc',
				borderWidth: 1,
				textStyle: {
					color: '#333',
					fontSize: 13,
				},
				padding: 12,
			},
			legend: {
				data: chartData?.dataset?.map((item) => item.label) || [],
				top: 0,
				left: 'center',
				itemGap: 15,
				padding: [0, 50, 10, 50],
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '18%',
				top: '80px',
				containLabel: true,
			},
			dataZoom: [
				{ type: 'slider', show: showSlider, xAxisIndex: 0, bottom: 10 },
				{ type: 'inside', xAxisIndex: 0 },
			],
			xAxis: {
				type: 'category',
				data: labels,
				name: 'X Axis',
				nameLocation: 'end',
				axisLabel: {
					interval: 0,
					rotate: labelsLength > 6 ? 45 : 0,
					fontSize: 11,
					width: 100,
					overflow: 'truncate',
					ellipsis: '...',
					formatter: function (value) {
						if (value && value.length > 20) {
							return value.substring(0, 20) + '...';
						}
						return value;
					},
				},
			},
			yAxis: {
				type: 'value',
				name: initialChartTabs?.find(
					(ele) =>
						ele?.value?.toLowerCase() ===
						selectedChartTab?.toLowerCase()
				)?.label,
				position: 'left',
				nameLocation: 'end',
				nameGap: 15,
				nameRotate: 0,
				nameTextStyle: {
					fontSize: 16,
					fontWeight: 'bold',
					align: 'left',
				},
			},
			series: (() => {
				let firstBarFound = false;
				return series.map((s, seriesIdx) => {
					const isFirstBarSeries = !firstBarFound && s.type === 'bar';
					if (!firstBarFound && s.type === 'bar')
						firstBarFound = true;
					if (isFirstBarSeries) {
						const markPointData_combined = [];

						if (
							selectedTab === 'periodWise' &&
							selectedTimeFilter === 'month' &&
							zeroProductionLabels.length > 0
						) {
							labels.forEach((label, idx) => {
								if (zeroProductionLabels.includes(label)) {
									markPointData_combined.push({
										name: `production_${label}`,
										coord: [idx, s.data[idx]],
										symbol: `image://${producedIcon}`,
										symbolSize: 28,
										symbolOffset: [0, -10],
										label: { show: false },
									});
								}
							});
						}

						if (markPointData.length > 0) {
							labels.forEach((label, idx) => {
								if (markPointData.includes(label)) {
									markPointData_combined.push({
										name: `alert_${label}`,
										coord: [idx, s.data[idx]],
										symbol: `image://${alert}`,
										symbolSize: 22,
										symbolOffset: [15, -15],
										label: { show: false },
									});
								}
							});
						}

						return {
							...s,
							markPoint: {
								data: markPointData_combined,
							},
						};
					}

					return s;
				});
			})(),
		};
	}, [
		chartData?.dataset,
		series,
		markPointData,
		selectedChartTab,
		selectedYear,
		zeroProductionLabels,
		selectedTab,
		selectedTimeFilter,
	]);

	const openModal = async (id, name = '', type = 'product') => {
		const req = {
			data: {
				dateRangeFilter: {
					from: moment(dateRangeObj?.from).format('YYYY-MM-DD'),
					to: moment(dateRangeObj?.to).format('YYYY-MM-DD'),
				},
				selectedTab: 'inventory',
				selectedSubTab: 'processwise',
				selectedDataFormat:
					selectedChartTab === 'count'
						? 'count'
						: selectedChartTab === 'weight'
						? 'weight'
						: 'cost',
				inventoryVariantIds: type === 'product' ? [id] : [],
				NO_CACHE: true,
				shiftId: filters?.type ? checkNull(filters?.type) : null,
				processIds: type === 'process' ? [id] : filters?.processIds,
				summaryDateGrouping: true,
			},
		};

		const notifyId = notificationServices.generateNotification({
			type: 'loading',
			message: `Fetching inventory details for ${name}...`,
		});

		try {
			const response = await aiPackaging?.fetchFmsAnalyticsGrid(req);
			notificationServices.closeNotification(notifyId);

			if (
				response?.statusCode === 200 &&
				response?.data?.data?.length > 0
			) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'Data fetched successfully',
				});
				dispatch(
					modalActions.toggleCustomModal(true, {
						header: `Inventory Details - ${name}`,
						width: '90vw',
						height: '70vh',
						bodyContent: (
							<ProductionDetailsModalContent
								rawData={response.data}
								id={id}
								name={name}
								dateRange={dateRangeObj}
								filters={filters}
								initialTab={
									selectedChartTab === 'count'
										? 'count'
										: selectedChartTab === 'weight'
										? 'weight'
										: 'cost'
								}
								type={type}
							/>
						),
						showCloseButton: true,
					})
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message || 'No data found or API error',
				});
			}
		} catch (error) {
			notificationServices.closeNotification(notifyId);
			notificationServices.generateNotification({
				type: 'error',
				message:
					error?.message || 'Error fetching modal inventory data',
			});
		}
	};

	const onChartClick = useCallback(
		(params) => {
			if (params?.componentType === 'series') {
				if (selectedTab === 'periodWise') {
					timeChartClick(
						selectedTimeFilter,
						params,
						timeFilterList,
						setTimeFilterList,
						setDateFilter,
						setSelectedTimeFilter,
						selectedYear,
						setFilters,
						filters
					);
				} else if (selectedTab === 'productGroupWise') {
					productChartClick(
						selectedTimeFilter,
						params,
						grouping,
						selectedTab,
						setTimeFilterList,
						setGrouping,
						setSelectedTimeFilter,
						chartData,
						isShowModal,
						openModal
					);
				} else if (selectedTab === 'geographyWise') {
					geographyChartClick(
						selectedTimeFilter,
						params,
						grouping,
						selectedTab,
						setTimeFilterList,
						setGrouping,
						setSelectedTimeFilter,
						chartData,
						isShowModal,
						openModal
					);
				}
				return;
			}
			if (params?.componentType === 'markPoint') {
				const clickedName = String(params?.name);
				if (clickedName.startsWith('production_')) {
					dispatch(
						modalActions.toggleMultiplePoModal(true, {
							mode: 'dataEntry',
						})
					);
				} else if (clickedName.startsWith('alert_')) {
					dispatch(modalActions.toggleRmPriceModal(true));
				}
				return;
			}
		},
		[
			selectedTab,
			selectedTimeFilter,
			timeFilterList,
			selectedYear,
			grouping,
			chartData,
			zeroProductionLabels,
			dispatch,
			filters,
			setFilters,
		]
	);

	const onEvents = useMemo(
		() => ({
			click: onChartClick,
		}),
		[onChartClick]
	);

	const exportInfo = {
		showExportBtn: false,
		hideExportAccordian: true,
	};

	const settingFilters = (filterData) => {
		setFilters({
			...filters,
			...(selectedTab === 'periodWise' &&
				selectedTimeFilter === 'day' &&
				selectedChartTab === 'weight' && {
					timeTypeFilter: 'PerHour',
				}),
			product: filterData?.product,
			type: filterData?.type,
			store: filterData?.store,
			multiStore: filterData?.multiStore,
			processIds: filterData?.allProcessTypeMulti?.id,
			allProcessTypeMulti: filterData?.allProcessTypeMulti,
		});
	};

	const handleYearSelection = useCallback(
		(year, type = 'year') => {
			setSelectedYear(year);
			setSelectedMonth(currentMonth);
			const baseList = getTimeFilterListForTab(
				selectedTab,
				brands,
				year,
				currentMonth
			);
			setTimeFilterList(baseList);
			setSelectedTimeFilter('month');
			setDateFilter({
				year: year,
				month: currentMonth,
				day: null,
				hour: null,
				week: null,
				currentSelection: 'month',
			});
		},
		[
			selectedTab,
			brands,
			currentMonth,
			getTimeFilterListForTab,
			setSelectedYear,
		]
	);

	const [highlightCache, setHighlightCache] = useState(false);

	useEffect(() => {
		if (!loading && cacheTime && cacheTime !== 'Just now') {
			setHighlightCache(true);
			const timer = setTimeout(() => {
				setHighlightCache(false);
			}, 5000);
			return () => clearTimeout(timer);
		}
	}, [cacheTime, loading]);

	return (
		<div style={{ padding: '0px 20px' }}>
			<style>
				{`
					@keyframes shake-tilt {
						0% { transform: rotate(0deg); }
						25% { transform: rotate(-5deg); }
						50% { transform: rotate(5deg); }
						75% { transform: rotate(-5deg); }
						100% { transform: rotate(0deg); }
					}
					.animate-shake-tilt {
						animation: shake-tilt 0.2s ease-in-out 1s 2;
					}
				`}
			</style>
			<RmPriceUpdateModal />
			<MultiPoModal />
			<CustomModal />
			<ImagesFinder
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				onSubmit={settingFilters}
				avoidInitialCall={true}
				allStoreOption={false}
				initialState={filters}
			/>
			<BackdropLoader isLoading={loading} showProgress={true} />
			<div className='flex items-center justify-between mb-4'>
				<div className='flex items-center gap-4'>
					<h1 style={{ fontWeight: '600', color: '#1f2937' }}>
						Inventory Analysis
					</h1>
					<div className='inline-flex rounded-xl gap-2 p-1'>
						{analysisPhaseTypes?.map((ele) => {
							const isActive = analysisPhase === ele.value;
							return (
								<button
									key={ele.value}
									onClick={() => setAnalysisPhase(ele.value)}
									className={`${TAB_BUTTON_BASE} ${
										isActive
											? TAB_BUTTON_ACTIVE
											: TAB_BUTTON_INACTIVE
									}`}
								>
									{ele.label}
								</button>
							);
						})}
					</div>
					<div className='inline-flex rounded-xl gap-2 p-1'>
						{analysisSubTypes?.map((ele) => {
							const isActive = analysisSubType === ele.value;
							return (
								<button
									key={ele.value}
									onClick={() =>
										setAnalysisSubType(ele.value)
									}
									className={`${TAB_BUTTON_BASE} ${
										isActive
											? TAB_BUTTON_ACTIVE
											: TAB_BUTTON_INACTIVE
									}`}
								>
									{ele.label}
								</button>
							);
						})}
					</div>
				</div>
				<div className='flex-1 flex justify-end'>
					{filtersInfoChip(filtersInfo, {
						...filters,
						typeName: shifts?.find(
							(item) => item?.id === filters?.type
						)?.shiftName,
					})}
				</div>
			</div>
			{/* Chart tabs */}
			<div className='mb-4 flex w-full items-center justify-between gap-4'>
				<div className='inline-flex rounded-xl gap-2 p-1'>
					{chartTabs?.map((tab) => {
						const isActive = selectedChartTab === tab.value;
						return (
							<button
								key={tab.value}
								onClick={() => handleChartTabChange(tab.value)}
								className={`${TAB_BUTTON_BASE} ${
									isActive
										? TAB_BUTTON_ACTIVE
										: TAB_BUTTON_INACTIVE
								}`}
								disabled={tab.disabled === true ? true : false}
							>
								{tab.label}
							</button>
						);
					})}
				</div>
				<div className='flex items-center gap-2'>
					<Button
						onClick={() =>
							window.open(
								`${urls.EXTENSION}${
									urls.PROCESS_FLOW_NEW
								}?dateOnly=${encodeURIComponent(
									JSON.stringify({
										date: dateRangeObj?.to,
									})
								)}`,
								'_blank'
							)
						}
						className='flex items-center gap-2 px-4 py-2 text-black bg-yellow-400 rounded-md hover:bg-yellow-500'
					>
						<span className='text-nowrap'>Operation Flow</span>
						<SquareArrowOutUpRight className='size-4' />
					</Button>
					<Button
						onClick={() => {
							window.open(
								`${urls?.EXTENSION}${
									urls?.AIFMS_SUMMARY_DYNAMIC
								}?parentValue=INVENTORY&dateRange=${encodeURIComponent(
									JSON.stringify(dateRangeObj)
								)}`,
								'_blank'
							);
						}}
						className='flex items-center gap-2 px-4 py-2 text-black bg-yellow-400 rounded-md hover:bg-yellow-500'
					>
						<span className='text-nowrap'>Operation Summary</span>
						<SquareArrowOutUpRight className='size-4' />
					</Button>
					<Button
						onClick={() => {
							dispatch(drawerActions.toggleFiltersDrawer(true));
						}}
						className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>

			<StatsComp statsCards={cardsData} />
			{cacheTime && !loading && (
				<div className='flex w-full justify-end'>
					<span
						onClick={() => {
							if (loading) return;
							setIsCache(true);
							fetchInitialData(true);
						}}
						className={`flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold shadow-sm transition-all origin-center
									${
										loading
											? 'cursor-not-allowed opacity-50 bg-orange-50 border-orange-200 text-orange-600'
											: 'cursor-pointer'
									}
									${
										highlightCache
											? 'bg-orange-200 border-orange-400 text-orange-800 ring-4 ring-orange-100 shadow-md animate-shake-tilt'
											: 'bg-orange-100 border-orange-200 text-orange-700 hover:bg-orange-200 hover:shadow-md duration-300'
									}`}
					>
						{loading ? (
							<Loader2 size={12} className='animate-spin' />
						) : (
							<RefreshCcw size={12} />
						)}
						Last Synced {cacheTime}
					</span>
				</div>
			)}

			{/* Main tabs and filters */}
			<div className='mb-4 flex w-full items-center justify-between gap-4'>
				{/* <div
					className={`flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-2 shadow-sm ${
						perUnitToggle
							? 'bg-blue-50 border-blue-200 backdrop-blur-md bg-blue-50/70'
							: ''
					} ${selectedChartTab === 'cost' ? '' : 'opacity-0'}`}
				>
					<span className='text-sm font-medium text-slate-600'>
						Total Value
					</span>
					<Toggle
						checked={perUnitToggle}
						onChange={setPerUnitToggle}
						disabled={selectedChartTab !== 'cost'}
					/>
					<span
						className={`ml-2 text-[12px] font-semibold ${
							perUnitToggle ? 'text-blue-500' : 'text-slate-700'
						}`}
					>
						Per Unit
					</span>
				</div> */}

				<div className='inline-flex rounded-xl gap-2 p-1'>
					{tabs?.map((tab) => {
						const isActive = selectedTab === tab.value;
						return (
							<button
								key={tab.value}
								onClick={() => handleTabChange(tab.value)}
								className={`${TAB_BUTTON_BASE} ${
									isActive
										? TAB_BUTTON_ACTIVE
										: TAB_BUTTON_INACTIVE
								}`}
							>
								{tab.label}
							</button>
						);
					})}
				</div>
				{(selectedChartTab === 'weight' ||
					selectedChartTab === 'count') && (
					<div className='inline-flex rounded-xl gap-2 p-1'>
						{dataFilterTabs?.map((tab) => {
							const isActive =
								filters?.timeTypeFilter === tab.value;
							const isVisible = tab.condition({
								tab: selectedTab,
								selectedTimeFilter: selectedTimeFilter,
							});
							return isVisible ? (
								<button
									key={tab.value}
									onClick={() =>
										handleFilterChange(tab.value)
									}
									className={`${TAB_BUTTON_BASE} ${
										isActive
											? TAB_BUTTON_ACTIVE
											: TAB_BUTTON_INACTIVE
									}`}
								>
									{tab.label}
								</button>
							) : (
								<></>
							);
						})}
					</div>
				)}

				{/* Placeholder for new Date/Shift controls */}
				<div className='flex items-center gap-1 bg-gray-50 rounded border border-gray-200 p-0.5 shadow-none h-fit opacity-50 cursor-not-allowed select-none'>
					<div className='flex items-center gap-1 px-2 py-0.5 text-xs font-medium text-gray-500'>
						Hourly Data <ChevronDown size={12} />
					</div>
					<div className='h-3 w-px bg-gray-300 mx-0.5'></div>
					<div className='flex items-center gap-1 px-1'>
						<div className='p-0.5 text-gray-400'>
							<ChevronLeft size={12} />
						</div>
						<span className='text-xs font-medium text-gray-600'>
							7th Jan'26
						</span>
						<div className='p-0.5 text-gray-400'>
							<ChevronRight size={12} />
						</div>
					</div>
					<div className='h-3 w-px bg-gray-300 mx-0.5'></div>
					<div className='flex items-center gap-1 px-2 py-0.5 text-xs font-medium text-gray-500'>
						All Shifts <ChevronDown size={12} />
					</div>
				</div>

				{selectedTab === 'periodWise' && (
					<div className='flex items-center gap-2 shadow-sm'>
						<span className='text-sm font-medium text-slate-600'>
							Year:
						</span>
						<SelectPicker
							data={yearOptions()}
							value={selectedYear}
							onChange={(value) =>
								handleYearSelection(value, 'year')
							}
							cleanable={false}
							searchable={false}
							placeholder='Select Year'
							style={{ width: 120 }}
						/>
					</div>
				)}
				{selectedTab !== 'periodWise' && (
					<DateRangePicker
						appearance='subtle'
						placeholder='Select Date Range'
						format='dd MMM yyyy'
						style={{
							fontSize: '12px',
							color: '#4a5568',
							fontWeight: '500',
						}}
						value={[dateRangeObj?.from, dateRangeObj?.to]}
						onChange={handleCustomDateChange}
						character=' to '
						size='sm'
						cleanable={false}
						placement='bottomEnd'
						ranges={quickPickerRanges}
						renderValue={(value) => {
							if (!value || !value[0] || !value[1])
								return 'Select Date Range';
							return `${formatDate(value[0])} to ${formatDate(
								value[1]
							)}`;
						}}
						disabled={selectedTab === 'periodWise'}
					/>
				)}
			</div>

			<ReactECharts
				ref={chartRef}
				option={option}
				style={{ height: '400px', width: '100%', marginBottom: '0' }}
				onEvents={onEvents}
				notMerge={true}
				showLoading={loading}
				loadingOption={{
					text: 'Loading chart data. Please do not refresh the page.',
					color: '#fbbf24',
					textColor: '#000',
					maskColor: 'rgba(255, 255, 255, 0.8)',
				}}
			/>

			{/* Time filter list */}
			<div
				style={{
					position: 'relative',
					height: '40px',
					background: '#f3f4f6',
					borderRadius: '5px',
					overflow: 'hidden',
					display: 'flex',
					alignItems: 'center',
					boxShadow:
						'0 2px 8px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.5)',
					border: '1px solid rgba(0, 0, 0, 0.05)',
					marginTop: '0',
				}}
			>
				{timeFilterList.map((item) => (
					<div
						key={item.value}
						onClick={() => handleTimeFilterChange(item.value)}
						className={`flex-1 text-center cursor-pointer ${
							selectedTimeFilter === item.value
								? 'bg-yellow-300'
								: ''
						}`}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '100%',
							padding: '0 8px',
						}}
					>
						{item?.label}
						{item?.tagList?.map(
							(tag) =>
								tag.condition(item.label, selectedYear) && (
									<span
										key={tag.label}
										style={{
											backgroundColor: tag.color,
											color: 'white',
											borderRadius: '4px',
											padding: '2px 6px',
											marginLeft: '8px',
										}}
									>
										{tag.label}
									</span>
								)
						)}
					</div>
				))}
			</div>
			{/* Hidden Month Picker */}
			<DatePicker
				ref={monthPickerRef}
				format='MMM yyyy'
				open={monthPickerOpen}
				onClose={() => setMonthPickerOpen(false)}
				onChange={handleMonthSelect}
				value={
					dateFilter?.month
						? new Date(selectedYear, dateFilter.month - 1, 1)
						: new Date(selectedYear, currentMonth - 1, 1)
				}
				placement='top'
				style={{
					position: 'absolute',
					bottom: '50px',
					left: '50%',
					transform: 'translateX(-50%)',
					opacity: monthPickerOpen ? 1 : 0,
					pointerEvents: monthPickerOpen ? 'auto' : 'none',
					zIndex: 1000,
				}}
				cleanable={false}
				oneTap
				shouldDisableDate={(date) => date > today}
			/>
		</div>
	);
}

export default InventoryAnalysisBeta;
